// extracted by mini-css-extract-plugin
export var contentCTA = "ungated-content-layout-module--contentCTA--754f1";
export var contentDescription = "ungated-content-layout-module--contentDescription--702b0";
export var contentTitle = "ungated-content-layout-module--contentTitle--4b5d4";
export var contentType = "ungated-content-layout-module--contentType--d6462";
export var ctaContainer = "ungated-content-layout-module--ctaContainer--c3340";
export var heroContentContainer = "ungated-content-layout-module--heroContentContainer--395f1";
export var heroLayoutContainer = "ungated-content-layout-module--heroLayoutContainer--13ce8";
export var moduleContainer = "ungated-content-layout-module--moduleContainer--304b4";
export var reactPlayer = "ungated-content-layout-module--reactPlayer--5a822";
export var relatedResource = "ungated-content-layout-module--relatedResource--acfc8";
export var relatedResourceContent = "ungated-content-layout-module--relatedResourceContent--0c4aa";
export var relatedResources = "ungated-content-layout-module--relatedResources--e97a7";
export var relatedResourcesContainer = "ungated-content-layout-module--relatedResourcesContainer--bb00c";
export var relatedResourcesLayout = "ungated-content-layout-module--relatedResourcesLayout--3202a";